
import 'antd/dist/antd.css'
import { ComponentBridge } from 'apprise-frontend-core/utils/bridge'
import { LazyBusyGuard } from 'apprise-frontend-core/utils/busyguard'
import { usePublicUrl } from 'apprise-frontend-core/utils/publicurl'
import { UIConfig, UIConfigProvider } from 'apprise-ui/context'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { IconContext } from 'react-icons/lib'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { bridge } from './bridge/bridge'
import { PreferencesProvider } from './preferences'
import { UsernameResolverProvider } from './usernameresolver'
import { PropsWithChildren } from 'react'

export type UserInterfaceProps = PropsWithChildren<Partial<UIConfig>>

export const UserInterface = (props: UserInterfaceProps) => {

    const { children, ...rest } = props

    const { baseUrl } = usePublicUrl()

    return (

        <UIConfigProvider {...rest} >
            <ComponentBridge bridge={bridge}>
                <BrowserRouter basename={baseUrl}>
                    <DndProvider backend={HTML5Backend}>
                        <ToastContainer />
                        <IconContext.Provider value={{ className: "apprise-icon" }}>
                            <LazyBusyGuard>
                                <PreferencesProvider>
                                    <UsernameResolverProvider>
                                        {children}
                                    </UsernameResolverProvider>
                                </PreferencesProvider>
                            </LazyBusyGuard>
                        </IconContext.Provider>
                    </DndProvider>
                </BrowserRouter>
            </ComponentBridge>
        </UIConfigProvider>
    )
}

